<div class="content">

    <div class="text-left mt-5">



        <h3>List Jobs [Customer]</h3> <br>

        <p>List all Job with pagination support. It will fetch first 100 Job details if Job is more than 100 for the
            particular customer along with next token to fetch next 100.Similarly it will go on until the next token is
            empty. The user has to use next token to get all matching Jobs to the user.</p><br>

        <p class="text-muted">QUERY PARAMETERS</p><hr><br>


        <div class="table-responsive">
            <table class="table table-primary table-bordered">
                <tbody>

                    <tr>
                        <td>
                            <h6>id</h6>
                        </td>
                        <td colspan="4">
                            <small>string^[-a-z0-9_]+$</small>
                            <p>
                                The Job id to fetch the next 100 job details. This needs to be passed only if you get a value as a response for the previous request in the LastEvaluatedKey field.
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <h6>created_at_user_id</h6>
                        </td>
                        <td colspan="4">
                            <small>string^[-a-z0-9_]+$</small>
                            <p>
                                The created_at_user_id to fetch the next 100 Job details. This needs to be passed only if you get a value as a response for the previous request in the LastEvaluatedKey field.
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <h6>user_id</h6>
                        </td>
                        <td colspan="4">
                            <small>string^[-a-z0-9_]+$</small>
                            <p>
                                The user_id to fetch the next 100 Job details for the particular user. This needs to be passed only if you get a value as a response for the previous request in the LastEvaluatedKey field.
                            </p>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div><br>


        <div class="card text-bg-dark mb-3">
            <div class="card-body">
                <pre><button type="button" class="btn btn-success">GET</button>  https://api.optimusdrive.ai/vod/v1/video/job</pre>
            </div>
        </div> <br><br>


        <h5>Example Request</h5><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">
    
                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>
                   
                <pre><code [innerHTML]="requestData"></code></pre>
            </div>
        </div><br><br>


        <div>

            <h5>Response samples</h5><br>

            <div class="card text-bg-light mb-3">
                <div class="card-body">
                  <!-- <button style="float: right;" type="button" class="btn btn-danger btn-sm" (click)="close()">
                    <i class="fa fa-close mr-2"></i>
                  </button> -->
        
                  <div class="panel panel-primary">
                    <div class="tab-menu-heading">
                      <ul class="nav nav-pills" role="tablist">
                        <!-- Tab menu items -->
                        <li class="nav-item" role="presentation">
                          <button class="nav-link active" id="tab1" data-bs-toggle="tab" data-bs-target="#content1"
                            type="button" role="tab" aria-controls="content1" aria-selected="true">200</button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#content2" type="button"
                            role="tab" aria-controls="content2" aria-selected="false">502</button>
                        </li>

                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#content3" type="button"
                            role="tab" aria-controls="content2" aria-selected="false">401</button>
                        </li>

                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#content4" type="button"
                            role="tab" aria-controls="content2" aria-selected="false">400</button>
                        </li>

                      </ul>
                    </div>
        
                    <div class="panel-body tabs-menu-body mt-4">
                      <div class="tab-content">
                        <!-- Tab content -->
                        <div class="tab-pane fade show active" id="content1" role="tabpanel" aria-labelledby="tab1">
                          <div class="card-body">
                            <pre><code [innerHTML]="sucessData" ></code></pre>
                          </div>
                        </div>
                        <div class="tab-pane fade" id="content2" role="tabpanel" aria-labelledby="tab2">
                          <div class="card-body">
                            <pre><code [innerHTML]="Error5x" ></code></pre>
                          </div>
                        </div>

                        <div class="tab-pane fade" id="content3" role="tabpanel" aria-labelledby="tab3">
                          <div class="card-body">
                            <pre><code [innerHTML]="Error4x" ></code></pre>
                          </div>
                        </div>

                        <div class="tab-pane fade" id="content4" role="tabpanel" aria-labelledby="tab3">
                          <div class="card-body">
                            <pre><code [innerHTML]="Error401x" ></code></pre>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
        
                </div>
              </div>
        
        </div>





        </div>


    </div>
